<svg class="{iconClass}" width="35" height="45" viewBox="-5 -5 152 203" xmlns="http://www.w3.org/2000/svg">
    <defs>
        <path id="shape" d="M 71 0 C 119 0, 142 37, 142 76 S 95 166, 71 193 C 46 166, 0 115, 0 76 S 23 0, 71 0Z" />
    </defs>
    <use xlink:href="#shape" transform="translate(0)" class="locationIcon"  fill="#CC001E"/>
    <text class="debug ug-hidden" x="70" y="75" dominant-baseline="middle" text-anchor="middle" font-size="50px">{locationName}</text>
    <text class="IconText" x="70" y="75" dominant-baseline="middle" text-anchor="middle" font-size="50px">{iconValue}</text>
</svg>